import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { ServiceRequest, RequestStatus, PaymentStatus } from '../../../types/serviceRequest';
//import sharedStyles from '../../SharedPageStyles.module.css';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';

type OpenDeleteDialogFn = (request: ServiceRequest) => void;

// دوال مساعدة لعرض الحالات بألوان
const renderRequestStatus = (status: RequestStatus) => {
  const styles: { [key in RequestStatus]: { color: string, text: string } } = {
    [RequestStatus.PENDING_REVIEW]: { color: 'orange', text: 'معلق' },
    [RequestStatus.PENDING_COMMITTEE]: { color: 'blue', text: 'قيد التنفيذ' },
    [RequestStatus.COMPLETED]: { color: 'green', text: 'مكتمل' },
    [RequestStatus.REJECTED]: { color: 'red', text: 'مرفوض' },
    [RequestStatus.APPROVED]: { color: '#28a745', text: 'موافق عليه' },
  };
  
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

const renderPaymentStatus = (status: PaymentStatus) => {
  const styles: { [key in PaymentStatus]: { color: string, text: string } } = {
    [PaymentStatus.PENDING]: { color: 'orange', text: 'بانتظار الدفع' },
    [PaymentStatus.PAID]: { color: 'green', text: 'مدفوع' },
    [PaymentStatus.FAILED]: { color: 'red', text: 'فشل الدفع' },
  };
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

export const getServiceRequestColumns = (openDeleteDialog: OpenDeleteDialogFn): ColumnDef<ServiceRequest>[] => [
  {
    header: 'اسم الخدمة',
    accessorFn: (row) => row.service?.name || 'غير محدد',
  },
  {
    header: 'مقدم الطلب',
    accessorFn: (row) => row.user?.name || 'غير محدد',
  },
  {
    header: 'حالة الطلب',
    accessorKey: 'status',
    cell: ({ row }) => renderRequestStatus(row.original.status),
  },
  {
    header: 'حالة الدفع',
    accessorKey: 'payment_status',
    cell: ({ row }) => renderPaymentStatus(row.original.payment_status),
  },
  {
    header: 'الرسوم',
    accessorKey: 'fee',
    cell: ({ row }) => `${row.original.fee} ر.ي`,
  },
  {
    header: 'تاريخ الطلب',
    accessorFn: (row) => new Date(row.created_at).toLocaleDateString('ar-EG'),
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const request = row.original;
      return (
        <div className={pageStyles.actionButtons}>
          <Link to={`/admin/service-requests/edit/${request.id}`} className={`${pageStyles.actionButton} ${pageStyles.edit}`} title="عرض / تعديل">
            <Icon as={FaEdit} style={pageStyles.icon } />
          </Link>
          <button onClick={() => openDeleteDialog(request)} className={`${pageStyles.actionButton} ${pageStyles.delete}`} title="حذف">
              <Icon as={FaTrashAlt} style={pageStyles.icon } />
          </button>
        </div>
      );
    },
  },
];
